import {
  ADD_FACILITIES, CHANGE_STATUS_FACILITIES,
  DELETE_FACILITIES,
  EDIT_FACILITIES,
  GET_FACILITIES,
} from "./facilities.types";

export const getFacilities = (params,  noLoad = false) => {
  return {
    type: GET_FACILITIES,
    payload: {
      params,
      noLoad
    },
  };
};

export const addFacility = (body) => {
  return {
    type: ADD_FACILITIES,
    payload: {
      body,
    },
  };
};

export const editFacility = (id, body) => {
  return {
    type: EDIT_FACILITIES,
    payload: {
      id,
      body,
    },
  };
};

export const deleteFacility = (id) => {
  return {
    type: DELETE_FACILITIES,
    payload: {
      id,
    },
  };
};

export const changeStatus = (id, body) => {
  return {
    type: CHANGE_STATUS_FACILITIES,
    payload: {
      id,
      body,
    },
  };
};